import request from '@/utils/request'

export const adminMessageList = (data = {}) => request({ url: '/api/estate/v1/oa/adminMessageList', method: 'post', data })

export const adminMessageCount = (data = {}) => request({ url: '/api/estate/v1/oa/adminMessageCount', method: 'post', data })

export const adminMessageUpd = (data = {}) => request({ url: '/api/estate/v1/oa/adminMessageUpd', method: 'post', data })



export const adminMsgAllRead = (data = {}) => request({ url: '/api/estate/v1/oa/adminMsgAllRead', method: 'post', data })

export const myAdminMessageCount = (data = {}) => request({ url: '/api/estate/v1/oa/adminMessageCount', method: 'post', data })

export const getMessageCount = (data = {}) => request({ url: '/api/estate/v1/oa/getMessageCount', method: 'post', data })


// 已完成